import moment from 'moment'

const defaultState = {
  fetched: false,
  fetching: false,
  fetchError: false,
  error: null,

  id: null,
  subject: '',
  fromDate: null,
  toDate: null,
  description: '',
  normalSubjects: [],
  personSubjects: [],
  color: 1,
  appointmentPrivate: false
}

export default function reducer(state=defaultState, action) {

    switch (action.type) {
      case "UPDATE_FETCH_APPOINTMENT": {
        return {
          ...state,
          fetched: false,
          fetching: true,
          fetchError: false
        }
      }
      case "UPDATE_FETCH_APPOINTMENT_COMPLETE": {
        return {
          ...state,
          fetched: true,
          fetching: false,
          fetchError: false,
          error: null,

          id: action.payload.id,
          subject: action.payload.onderwerp,
          fromDate: moment(action.payload.van_datum+action.payload.van_tijd, 'YYYYMMDDHH:mm'),
          toDate: moment(action.payload.tot_datum+action.payload.tot_tijd, 'YYYYMMDDHH:mm'),
          description: action.payload.beschrijving,
          normalSubjects: action.payload.onderwerpen.map(subject => (
            {
              id: subject.id,
              type: subject.id_type,
              value: subject.onderwerp
            }
          )),
          personSubjects: action.payload.personen.map(subject => (
            {
              id: subject.id,
              type: subject.id_type,
              value: subject.persoon
            }
          )),
          color: action.payload.kleuren.id,
          appointmentPrivate: action.payload.prive
        }
      }
      case "UPDATE_FETCH_APPOINTMENT_REJECTED": {
        return {
          ...state,
          fetched: false,
          fetching: false,
          fetchError: true
        }
      }
      case "UPDATE_APPOINTMENT_SET_SUBJECT": {
        return {
          ...state,
          subject: action.payload
        }
      }

      case "UPDATE_APPOINTMENT_SET_FROM_DATE": {
        return {
          ...state,
          fromDate: action.payload
        }
      }

      case "UPDATE_APPOINTMENT_SET_TO_DATE": {
        return {
          ...state,
          toDate: action.payload
        }
      }

      case "UPDATE_APPOINTMENT_SET_DESCRIPTION": {
        return {
          ...state,
          description: action.payload
        }
      }

      case "UPDATE_APPOINTMENT_ADD_NORMAL_SUBJECT": {
        return {
          ...state,
          normalSubjects: [
            ...state.normalSubjects,
            {type: 1, value: ''}
          ]
        }
      }
      case "UPDATE_APPOINTMENT_DELETE_NORMAL_SUBJECT": {
        return {
          ...state,
          normalSubjects: state.normalSubjects.filter((_, i) => i !== action.payload)
        }
      }
      case "UPDATE_APPOINTMENT_UPDATE_NORMAL_SUBJECT": {
        let newNormalSubjects = [...state.normalSubjects]
        newNormalSubjects[action.payload.idx] = action.payload.newSubject
        return {
          ...state,
          normalSubjects: newNormalSubjects
        }
      }

      case "UPDATE_APPOINTMENT_ADD_PERSON_SUBJECT": {
        return {
          ...state,
          personSubjects: [
            ...state.personSubjects,
            {type: 2, value: ''}
          ]
        }
      }
      case "UPDATE_APPOINTMENT_DELETE_PERSON_SUBJECT": {
        return {
          ...state,
          personSubjects: state.personSubjects.filter((_, i) => i !== action.payload)
        }
      }
      case "UPDATE_APPOINTMENT_UPDATE_PERSON_SUBJECT": {
        let newPersonSubjects = [...state.personSubjects]
        newPersonSubjects[action.payload.idx] = action.payload.newSubject
        return {
          ...state,
          personSubjects: newPersonSubjects
        }
      }

      case "UPDATE_APPOINTMENT_SET_COLOR": {
        return {
          ...state,
          color: action.payload
        }
      }

      case "UPDATE_APPOINTMENT_SET_PRIVATE": {
        return {
          ...state,
          appointmentPrivate: action.payload
        }
      }

      case "UPDATE_APPOINTMENT_SET_ERRORS": {
        return {
          ...state,
          error: action.payload
        }
      }

      default:{
        return state
      }
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/updateAppointmentReducer.js